import { render, staticRenderFns } from "./JobMatchingDesired.vue?vue&type=template&id=6dcb8024"
import script from "./JobMatchingDesired.vue?vue&type=script&lang=js"
export * from "./JobMatchingDesired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports